import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Trans } from 'react-i18next';
import i18n from 'i18n';
import Tip from 'components/Common/Template/Tip';
import GuidePopup from 'components/Common/Popup/GuidePopup';
import * as popupActions from 'redux/ducks/common/popupDucks';
import PopupBoard from './PopupBoard';

export const TabBoard = () => {
  const dispatch = useDispatch();
  const isShowGuide = useSelector(state => state.popup.isShowGuide);
  return (
    <>
      <div className="content">
        <div className="tab img-area board" />
        <div className="left-wrap">
          <div className="wrapper">
            <div className="large-title">
              <Trans i18nKey="BTY_W_T_ADD_BORD_GUIDE_T" />
            </div>
          </div>
          <div className="large-text">
            <Trans i18nKey="BTY_W_T_ADD_BORD_GUIDE1" />
          </div>
          <div className="info">
            <i className="ic-info-solid-gray sm" />
            <div>
              <p className="sub-text">{i18n.t('BTY_W_T_ADD_BORD_GUIDE2')}</p>
            </div>
          </div>
          <div className="large-text">
            <div
              className="link"
              onClick={() => {
                dispatch(popupActions.openGuide());
              }}
            >
              {i18n.t('BTY_W_T_GUID_POTLIT')}
            </div>
          </div>
        </div>
      </div>
      <Tip subText={i18n.t('BTY_W_T_BOARD_INFO')} />
      {isShowGuide && (
        <GuidePopup
          title={i18n.t('BTY_W_T_GUID_POTLIT')}
          contents={i18n.t('BTY_W_T_GUID_POTLIT_INFO')}
          imgName="img_board1"
        />
      )}

      <PopupBoard />
    </>
  );
};

export default TabBoard;
